import { render, staticRenderFns } from "./UpProof.vue?vue&type=template&id=7278fe1a&scoped=true"
import script from "./UpProof.vue?vue&type=script&lang=js"
export * from "./UpProof.vue?vue&type=script&lang=js"
import style0 from "./UpProof.vue?vue&type=style&index=0&id=7278fe1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278fe1a",
  null
  
)

export default component.exports